import { useEffect, useState } from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LIGHT = { baseColor: "#ebebeb", highlightColor: "#f5f5f5" };
const DARK = { baseColor: "#2a3142", highlightColor: "#3d465c" };

function readIsDarkMode() {
  if (typeof document === "undefined") return false;
  return (
    document.body.classList.contains("dark-mode") ||
    localStorage.getItem("darkMode") === "true"
  );
}

/** Light/dark colors for react-loading-skeleton. */
export default function DarkAwareSkeletonTheme({ children }) {
  const [isDark, setIsDark] = useState(readIsDarkMode);

  useEffect(() => {
    setIsDark(readIsDarkMode());
    const observer = new MutationObserver(() => setIsDark(readIsDarkMode()));
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const colors = isDark ? DARK : LIGHT;

  return (
    <SkeletonTheme
      baseColor={colors.baseColor}
      highlightColor={colors.highlightColor}
    >
      {children}
    </SkeletonTheme>
  );
}
